module.exports = __webpack_public_path__ + "static/luminous_0-5ca4b0fd77064892a0d5d8d0b3878caf.png";